import { OverlappingEmpForm } from '~/features/OverlappingEmploymentDialog/hooks/useOverlappingEmploymentForm';
import { fetchFromOldApi } from '~/services/Http';

export const saveCustomData = async (
  employeeId: number,
  form: OverlappingEmpForm,
) => {
  const url = `/json/customdata/EMPLOYEE/${employeeId}`;
  const customData = form.overlappingEmployment.customData;
  Object.keys(customData).forEach((field) => {
    if (typeof customData[field] === 'boolean') {
      customData[field] = String(customData[field]);
    }
  });
  return await fetchFromOldApi(url, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(customData),
  })
    .then((r) => r.json())
    .catch((e) => {
      console.log('saveCustomData', e);
    });
};
